/**
 * Get the user's IP address using an external API
 * Falls back to "unknown" if the request fails
 */
export const getIpAddress = async (): Promise<string> => {
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error('Failed to fetch IP address:', error);
    // Fallback to empty string or you can try another service
    try {
      const response = await fetch('https://api.my-ip.io/ip');
      const data = await response.json();
      return data.ip;
    } catch (secondError) {
      console.error('Failed to fetch IP address from backup service:', secondError);
      return 'unknown';
    }
  }
};
